import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfigResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  get() {
    return this.httpClient.get(ApiConfig.baseURL + 'api/rest/appconfigs', {headers: ApiConfig.requestOptionsHeaderForJson});
  }

  getById(key, subKey) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/rest/appconfigs/' + key + '/' + subKey, {headers: ApiConfig.requestOptionsHeaderForJson});
  }

  post(body: Object) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/rest/appconfigs', body, {headers: ApiConfig.requestOptionsHeaderForJson});
  }

  deleteById(key, subKey) {
    return this.httpClient.delete(ApiConfig.baseURL + 'api/rest/appconfigs/' + key + '/' + subKey, {headers: ApiConfig.requestOptionsHeaderForJson});
  }
}
